import dynamic from 'next/dynamic';
import { ComponentType, useEffect, useState } from 'react';

import { useSponsoredPlaylistData } from '@/productDiscovery/SponsoredProductRecommendation/modules/SponsoredProductRecommendation/hooks/useSponsoredPlaylistData';
import { SPONSORED_PRODUCT_MIN_LENGTH } from '@/productDiscovery/SponsoredProductRecommendation/services/constants';

import { RecommendationPlaceholder } from '../../../../components/Recommendation/Recommendation.placeholder';
import { useFrequentlyBoughtTogetherPlaylist } from './FrequentlyBoughtTogetherPlaylist/FrequentlyBoughtTogetherPlaylist';
import { useSimilarityPlaylist } from './SimilarityTopPlaylist/SimilarityTopPlaylist';

const SponsoredPlaylistContainer = dynamic(
  () =>
    import(
      '@/productDiscovery/ProductPage/common/modules/SponsoredPlaylist/SponsoredPlaylist.container'
    ).then((mod) => mod.SponsoredPlaylistContainer),
  {
    ssr: true,
    loading: () => <RecommendationPlaceholder />,
  },
);

const SimilarityPlaylist = dynamic(
  () =>
    import('./SimilarityTopPlaylist/SimilarityTopPlaylist').then(
      (mod) => mod.default,
    ),
  {
    ssr: true,
    loading: () => <RecommendationPlaceholder />,
  },
);

const FrequentlyBoughtTogetherPlaylist = dynamic(
  () =>
    import(
      './FrequentlyBoughtTogetherPlaylist/FrequentlyBoughtTogetherPlaylist'
    ).then((mod) => mod.default),
  {
    ssr: false,
    loading: () => <RecommendationPlaceholder withAddToCart />,
  },
);

const usePlaylistPDP = (): Array<ComponentType> => {
  const { data: sponsoredPlaylistData, fetched: sponsoredPlaylistDataFetched } =
    useSponsoredPlaylistData();
  const { isSimilarityAvailable } = useSimilarityPlaylist();
  const { isFBTAvailable } = useFrequentlyBoughtTogetherPlaylist();
  const [isSPAvailable, setIsSPAvailable] = useState(
    sponsoredPlaylistDataFetched &&
      sponsoredPlaylistData.length > SPONSORED_PRODUCT_MIN_LENGTH,
  );

  useEffect(() => {
    if (sponsoredPlaylistDataFetched) {
      setIsSPAvailable(
        sponsoredPlaylistData.length > SPONSORED_PRODUCT_MIN_LENGTH,
      );
    }
  }, [sponsoredPlaylistData.length, sponsoredPlaylistDataFetched]);

  let playlists: Array<ComponentType> = [];
  playlists.length = 3;
  playlists.fill(() => null);

  playlists = [
    ...(isSPAvailable ? [SponsoredPlaylistContainer] : []),
    ...(isSimilarityAvailable ? [SimilarityPlaylist] : []),
    ...(isFBTAvailable ? [FrequentlyBoughtTogetherPlaylist] : []),
    ...playlists,
  ];

  playlists.length = 3;

  return playlists;
};

usePlaylistPDP.displayName = 'usePlaylistPDP';

export default usePlaylistPDP;
